import React from 'react';
import { useSelector } from 'react-redux';
import { ButtonType } from '../../../../../ui/buttonTypes';
import StudentInfo from '../../shared/StudentInfo/StudentInfo';
import BtnComponent from '../../../../ui/buttons/BtnComponent';
import iconsList from '../../../../ui/icons/iconsList';
import classes from './studentRegistrationStage.module.css';

const StudentRegistrationStage = () => {

    const { texts } = useSelector((state) => state.translate);

    return (
        <div className={`${classes.studentRegistrationStage} `}>
            <div className={classes.rightAndMiddleWrapper}>
                <StudentInfo />
                <p className={classes.simpleText}>{texts.middleTextStudentBefore}</p>
            </div>
            <BtnComponent type={ButtonType.ANCHOR} icon={iconsList.victoryCup}  text={texts.btnMeetContest} anchorId="contest-info-section" />
        </div>
    );
};

export default StudentRegistrationStage;

